import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of, Subject, BehaviorSubject } from 'rxjs';
import { Regel } from '../models/Regel';
import { RegelSet } from '../models/RegelSet';
import { RegelsService } from '../services/regels.service';
import { genericSortingAccessor } from '../shared.module';
import { RegelDialogComponent } from './dialogs/regel-dialog.component';
import { RegelSetActieComponent } from './regel-set-actie.component';

@Component({
  selector: 'app-regel',
  templateUrl: './regel.component.html',
  styleUrls: ['./beheer-regels.component.scss']
})
export class RegelComponent implements OnInit {
  @Output() aantalRegelsEvent = new EventEmitter<number>();

  public selectedRegelSet: string;

  dataSourceRegel = new MatTableDataSource<Regel>();
  displayedColumnsRegel: string[] = [
    'filter',
    'type',
    'waardeRegel',
    'heralarmeren',
    'action'
  ];
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private regelsSvc: RegelsService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.selectedRegelSet = params.get('regelSetId');
      console.log(this.selectedRegelSet);
    });
    this.refreshDataSourceRegel();
  }

  refreshDataSourceRegel(): void {
    this.regelsSvc.loadRegel(this.selectedRegelSet).subscribe((o) => {
      this.dataSourceRegel.data = o;
      this.dataSourceRegel.sort = this.sort;
      this.dataSourceRegel.sortingDataAccessor = genericSortingAccessor;

      this.aantalRegelsEvent.emit(this.dataSourceRegel.data.length);
    });
  }

  clickHandler(row) {
    /*   this.router.navigateByUrl(`regelSetActie/${row.regelSetId}`);*/
    console.log(row);
  }

  openDialog(action, obj) {
    obj.action = action;
    let dialogRef = this.dialog.open(RegelDialogComponent, {
      width: '60%',
      maxWidth: 'fit-content',
      data: obj
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result.event == 'Toevoegen') {
          this.addRowData(result.data);
        } else if (result.event == 'Bewerken') {
          this.updateRowData(result.data);
        } else if (result.event == 'Verwijderen') {
          this.deleteRowData(result.data);
        }
      }
    });
  }

  addRowData(row_obj: Regel) {
    console.log('Add');
    console.log(row_obj);
    const i: Regel = {
      regelSetId: +this.selectedRegelSet,
      regelId: 0,
      type: row_obj.type,
      waardeRegel: row_obj.waardeRegel,
      heralarmeren: row_obj.heralarmeren ? row_obj.heralarmeren : false,
      filter: row_obj.filter ? row_obj.filter : false
    };

    this.regelsSvc.saveRegel(i).subscribe(
      (r) => {
        const changeData = this.dataSourceRegel.data;
        this.dataSourceRegel.data = changeData.concat(r);
        this.aantalRegelsEvent.emit(this.dataSourceRegel.data.length);
      },
      (error) => {
        this.showErrorToast(error, 'Fout bij het opslaan');
      }
    );
  }
  updateRowData(row_obj: Regel) {
    console.log('edit');
    console.log(row_obj);

    const i: Regel = {
      regelSetId: +this.selectedRegelSet,
      regelId: row_obj.regelId,
      type: row_obj.type,
      waardeRegel: row_obj.waardeRegel,
      heralarmeren: row_obj.heralarmeren ? row_obj.heralarmeren : false,
      filter: row_obj.filter ? row_obj.filter : false
    };

    this.regelsSvc.saveRegel(i).subscribe(
      (r) => {
        const changeData = this.dataSourceRegel.data;
        const foundIndex = changeData.findIndex((x) => x.regelId === r.regelId);
        changeData[foundIndex] = r;
        this.dataSourceRegel.data = changeData;
      },
      (error) => {
        this.showErrorToast(error, 'Fout bij het opslaan');
      }
    );
  }
  deleteRowData(row_obj: Regel) {
    console.log('delete ');
    console.log(row_obj);

    const i: Regel = {
      regelSetId: +this.selectedRegelSet,
      regelId: row_obj.regelId,
      type: row_obj.type,
      waardeRegel: row_obj.waardeRegel,
      heralarmeren: row_obj.heralarmeren,
      filter: row_obj.filter
    };

    this.regelsSvc.deleteRegel(i.regelId).subscribe(
      (r) => {
        this.refreshDataSourceRegel();
      },
      (error) => {
        this.showErrorToast(error, 'Fout bij het opslaan');
      }
    );
  }

  showErrorToast(error: any, melding: string) {
    let tekst = melding;

    if (error.message) {
      tekst += '(' + error.message + ')';
    }

    this.snackBar.open(tekst, null, { duration: 3000 });
  }
}
